module.exports = __webpack_public_path__ + "a085ab83dfd6c9e4251d2d45c43df172.png";